/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const myReferralRowSchema = z.object({
  status: z.string(),
  rewardTier: z.string().nullable(),
  rewardDays: z.number().nullable(),
  createdAt: z.number(),
});

export const getMyReferralsV1ResponseDataSchema = z.object({
  activatedCount: z.number(),
  rewardDaysEarned: z.number(),
  currentTier: z.string().nullable(),
  nextTier: z.string().nullable(),
  nextTierAtActivated: z.number().nullable(),
  referrals: z.array(myReferralRowSchema),
});

export type IGetMyReferralsV1ResponseData = z.infer<typeof getMyReferralsV1ResponseDataSchema>;

export const getMyReferralsV1ResponseSchema = createApiResponseSchema(
  getMyReferralsV1ResponseDataSchema,
) as z.ZodSchema<IAPI<IGetMyReferralsV1ResponseData>>;

export type IGetMyReferralsV1Response = IAPI<IGetMyReferralsV1ResponseData>;
